import NOT01_001INS from "@/views/MINOTICE/NOT01_001INS.vue";

export default function minoticeRouter() {
  return [
    {
      path: "NOT01_001INS.xml",
      component: NOT01_001INS,
    },
  ];
}
